import Api from '@/services/Api'
import axios from 'axios'
import ApiTraccar from "./ApiTraccar";

export default {
  // Método que llama a la url para crear un chat
 getGeofences () {
   return Api().get("/geofences");
},
  updateGeofence (params) {
    return Api().put("/geofences",params);
  },
  addGeofence (params) {
    return Api().post("/geofences",params);
  },
  getGeofence (params) {
    return Api().get("/geofences/"+params);
  },
  getGeofencesByDevice (params) {
    return Api().get("/geofences-by-device/"+params);
  },
  deleteGeofence (params) {
    return Api().delete("/geofences/"+params);
  },
  getGeofencesTraccar () {
    return ApiTraccar().get("/geofences");
  },
  updateGeofenceTraccar (params) {
    return ApiTraccar().put("/geofences/"+params.id,params);
  },
  addGeofenceTraccar (params) {
    return ApiTraccar().post("/geofences",params);
  },
  linkGeofenceTraccarToDevice (params) {
    return ApiTraccar().post("/permissions",params);
  },
  unlinkGeofenceTraccarToDevice (params) {
    return ApiTraccar().delete("/permissions",params);
  },
  getGeofenceTraccar (params) {
    return ApiTraccar().get("/geofences/"+params);
  },
  deleteGeofenceTraccar (params) {
    return ApiTraccar().delete("/geofences/"+params);
  }
}






// WEBPACK FOOTER //
// ./src/services/GeofenceService.js